@if (evaluationData) {
    <tec-collapse
        [icon]="'icon-capture-popup'"
        [title]="'OPERATIONS.DETAIL.TABS.DETAILS.DATA' | translate"
        [expanded]="expandedCollapseSection === 'data'"
        (clickEvent)="toggleCollapse('data', $event)"
    >
        @if (isScoringType) {
            <tec-info-group [label]="'PROCESSES.DETAIL.SCORING' | translate">
                <span>{{ evaluationData.scoring }}</span>
                <tec-tag-icon
                    size="sm"
                    [icon]="evaluationData.state === OPERATION_STATUS.OK ? 'icon-check' : 'icon-alert'"
                    [status]="evaluationData.state === OPERATION_STATUS.OK ? 'success' : 'error'"
                />
            </tec-info-group>
        } @else {
            <tec-list-detail>
                <span>{{ evaluationTypeLabel | translate }}</span>
            </tec-list-detail>
        }
    </tec-collapse>

    <tec-collapse
        [icon]="'icon-pending-check'"
        [title]="'OPERATIONS.DETAIL.TABS.DETAILS.OPERATION' | translate"
        [expanded]="expandedCollapseSection === 'operation'"
        (clickEvent)="toggleCollapse('operation', $event)"
    >
        <app-operation-detail-operation-meta
            [operationUuid]="detail?.uuid"
            [processUuid]="detail?.process_uuid"
            [startAt]="evaluationData.start_at"
            [endAt]="evaluationData.end_at"
            [totalTime]="evaluationData.total_time"
            triesStyle="badge"
            [triesLabel]="totalTriesLabel"
            [state]="evaluationData.state"
            [showKoOnTries]="true"
            [typeLabel]="evaluationTypeLabel | translate"
            [obtainMethodLabel]="obtainMethodLabel | translate"
        />
    </tec-collapse>
} @else {
    <tec-empty-state [title]="'OPERATIONS.DETAIL.TABS.DETAILS.EMPTY' | translate" [size]="'default'" [type]="'empty'" />
}
